<div class="wk-data-table__heading-cell__content">
    @let castTitle = title();
    @if (column()?.isSafeValue(castTitle)) {
        <div
            class="wk-data-table__cell__value wk-data-table__heading-cell__value"
            [innerHTML]="castTitle"
            (click)="column()?.onColumnHeaderClicked($event)"
        ></div>
    } @else {
        <div class="wk-data-table__cell__value wk-data-table__heading-cell__value" (click)="column()?.onColumnHeaderClicked($event)">
            {{ castTitle }}
        </div>
    }
    @if (sortable() && sortInfo()) {
        <icon-pds3 name="wk-icon-arrow-down" />
    }
    @if (filterable() && column()?.definition.fieldname) {
        <wk-column-filter
            [filterName]="column()?.definition.fieldname ?? ''"
            [dynamicFilterName]="column()?.definition.dynamicFieldName"
            [showAllOptions]="true"
        />
    }
</div>

<ng-template cdkDragPreview />
